import { useCallback } from 'react';
import urlSlug from 'url-slug';

const useDownloadAsExcel = () => {
  const download = useCallback(async ({ fileName, sheetTitle, sheetHeader, sheetData }) => {
    const payload = {
      fileType: 'xlsx',
      data: {
        sheetData,
        sheetTitle,
        sheetHeader,
      },
    };

    const res = await fetch(`${process.env.MANAGER_BASE_PATH}/download`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      throw new Error(res.statusText);
    }

    const body = await res.arrayBuffer();

    const blob = new Blob(
      [body],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    );
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = urlSlug(fileName);
    link.click();
  });

  return download;
};

export default useDownloadAsExcel;
